import { useEffect, useState } from 'react';

import InfoCardPlaceholder from './InfoCardPlaceholder';

type Props = {
  title: string;
  image: string;
  description: string;
  buttonText: string;
  buttonURL: string;
  maxHeight: number;
};

const InfoCard = ({ title, image, description, buttonText, buttonURL, maxHeight }: Props) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsImageLoaded(true);
    }, 2000);
  }, []);

  return (
    <div
      className="w-[268px] overflow-y-auto overflow-x-hidden rounded-lg bg-white px-6 py-4 shadow-lg"
      style={{ maxHeight }}
    >
      {/* Placeholder mientras carga */}
      {!isImageLoaded && <InfoCardPlaceholder />}

      {/* Contenido real con animación de entrada */}
      <div
        className={`transition-all duration-500 ease-out ${
          isImageLoaded
            ? 'translate-y-0 opacity-100'
            : 'pointer-events-none absolute translate-y-4 opacity-0'
        }`}
      >
        <h4 className="mb-4 text-center font-montserrat text-lg font-semibold text-elfGreen">
          {title}
        </h4>
        <img
          className="mx-auto block w-full rounded object-cover"
          src={image}
          style={{ height: 110 }}
          onLoad={() => {
            setIsImageLoaded(true);
          }}
        />
        <div className="my-4 w-full overflow-hidden hyphens-auto font-workSans text-sm leading-4 text-black">
          {description}
        </div>
        <div className="flex justify-center">
          <a
            href={buttonURL}
            target="_blank"
            className="max-w-full rounded-full bg-primary px-3 py-2 font-workSans text-white"
          >
            {buttonText}
          </a>
        </div>
      </div>
    </div>
  );
};

export default InfoCard;
